import { apiTraceDeviceDiagnosisStream } from '@/apis/diagnosis.api'

let streamController = null

export const diagnosisModeLabels = {
	DEFAULT: '云版物联网平台',
	CLOUD_LINK: '连接平台-云版',
	LOCAL_LINK: '连接平台-公共通信链路(终端测试)',
	NB_CONVERT: 'NB转换服务',
}

export const candidateMode = device => {
	return device && diagnosisModeLabels[device.diagnosisMode] ? device.diagnosisMode : 'DEFAULT'
}

export default {
	state: {
		device: null,
		diagnosisMode: 'DEFAULT',
		detail: {},
		aiResult: null,
		streamStatus: 'idle',
		streamError: '',
	},
	getters: {
		hasDetail: state => Object.keys(state.detail).length > 0,
		streamActive: state => ['connecting', 'diagnosing'].includes(state.streamStatus),
		aiNotRequired: state => {
			return (
				state.detail.aiDiagnosis?.ineligibleReason === 'DIAGNOSIS_COMPLETE' ||
				state.aiResult?.failureCode === 'DIAGNOSIS_COMPLETE'
			)
		},
	},
	mutations: {
		SET_DIAGNOSIS_STATE(state, payload) {
			Object.assign(state, payload)
		},
	},
	actions: {
		async startDiagnosis({ commit, dispatch }, device) {
			const mode = candidateMode(device)
			const deviceNo = device.deviceNo
			if (mode === 'DEFAULT' && !device.deviceId) throw new Error('该设备缺少 deviceId')
			if (mode !== 'DEFAULT' && !deviceNo) throw new Error('该诊断来源缺少设备编号')
			dispatch('stopDiagnosis')
			commit('SET_DIAGNOSIS_STATE', {
				device: { ...device, diagnosisMode: mode },
				diagnosisMode: mode,
				detail: {},
				aiResult: null,
				streamError: '',
				streamStatus: 'connecting',
			})
			const controller = new AbortController()
			streamController = controller
			let terminalEvent = false
			try {
				await apiTraceDeviceDiagnosisStream(
					{
						diagnosisMode: mode,
						...(mode === 'DEFAULT' ? { deviceId: device.deviceId } : { deviceNo }),
					},
					{
						onRuleResult: result => {
							if (streamController !== controller) return
							commit('SET_DIAGNOSIS_STATE', {
								detail: { ...device, ...(result || {}) },
								streamStatus: 'diagnosing',
							})
						},
						onAiResult: result => {
							if (streamController !== controller) return
							commit('SET_DIAGNOSIS_STATE', { aiResult: result || {} })
						},
						onComplete: () => {
							if (streamController !== controller) return
							terminalEvent = true
							commit('SET_DIAGNOSIS_STATE', { streamStatus: 'completed' })
						},
						onError: error => {
							if (streamController !== controller) return
							terminalEvent = true
							commit('SET_DIAGNOSIS_STATE', {
								streamError: (error && error.message) || '通信链路诊断失败，请稍后重试',
								streamStatus: 'failed',
							})
						},
					},
					controller.signal,
				)
				if (streamController === controller && !terminalEvent) {
					commit('SET_DIAGNOSIS_STATE', {
						streamError: '实时诊断连接提前关闭，请重试',
						streamStatus: 'failed',
					})
				}
			} catch (error) {
				if (error.name !== 'AbortError' && streamController === controller) {
					commit('SET_DIAGNOSIS_STATE', {
						streamError: error.message || '通信链路诊断失败，请稍后重试',
						streamStatus: 'failed',
					})
				}
			} finally {
				if (streamController === controller) streamController = null
			}
		},
		ensureDiagnosis({ state, getters, dispatch }, { deviceId }) {
			// 路由 query 取到的 deviceId 是字符串，接口返回的是数字，这里用松散比较
			if (
				state.diagnosisMode === 'DEFAULT' &&
				state.device?.deviceId != null &&
				state.device.deviceId == deviceId &&
				(getters.hasDetail || getters.streamActive)
			)
				return
			return dispatch('startDiagnosis', { deviceId, diagnosisMode: 'DEFAULT' })
		},
		stopDiagnosis({ getters, commit }) {
			if (streamController) streamController.abort()
			streamController = null
			if (getters.streamActive) commit('SET_DIAGNOSIS_STATE', { streamStatus: 'idle' })
		},
	},
}
